import { event } from './ga';

const getUser = () => localStorage && JSON.parse(localStorage.getItem('user_data'));

export const shareButtonClicked = () => {
  const user = getUser();
  event({
    action: 'conv_insights_hub_share_click',
    params: {
      event_category: 'conv_insights_hub',
      event_label: 'Share CTA clicked in Insights Hub thread',
      user_id: user?.id,
    },
  });
};

export const threadListItemClicked = () => {
  const user = getUser();
  event({
    action: 'conv_insights_hub_thread_list_item_clicked',
    params: {
      event_category: 'conv_insights_hub',
      event_label: 'Clicked an item from thread list in Insights Hub',
      user_id: user?.id,
    },
  });
};

export const insightsHubTabSelected = () => {
  const user = getUser();
  event({
    action: 'conv_insights_hub_tab_selected',
    params: {
      event_category: 'conv_insights_hub',
      event_label: 'Clicked on Insights Hub tab in Conversation Insights',
      user_id: user?.id,
    },
  });
};